import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "fe75d1e9-81c4-4fba-bc68-75ce0a0aa29e", content: "lower frequencies (f<1.5 kHz)", options: {} },
  { id: "df0c4ca4-bec6-4f0a-815e-bef64da3f2b4", content: "higher frequencies (f>1.5 kHz)", options: {} },
  { id: "7f1e91f7-08eb-4b3d-a4a1-1818eb5e8e74", content: "shorter wavelengths", options: {} },
  { id: "38c3b9e5-98d8-4010-bc51-f939c0db8f58", content: "higher frequencies frequencies  (f>1.5 kHz)", options: {} },
  { id: "2420ad73-1544-4929-8be1-36ac9e7e708a", content: "longer wavelengths", options: {} },
  { id: "876299be-4c6d-4316-b19c-9618bc16cff4", content: "shorter wavelengths", options: {} },
];

export const task: Task = {
  id: "e3b71f02-fa53-4a50-8080-1487c77d5cde",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: false,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "fe75d1e9-81c4-4fba-bc68-75ce0a0aa29e",
    "38c3b9e5-98d8-4010-bc51-f939c0db8f58",
    "876299be-4c6d-4316-b19c-9618bc16cff4",
  ],
};
